export default "__VITE_ASSET__BYl33hia__"